import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { saveQuestionAnswerAtAll } from '../actions/shared';
import QuestionOptionResult from './QuestionOptionResult';
import styled from 'styled-components';

function QuestionDetail(props) {
  const {} = useSelector(({ auth, users, questions }) => ({
    authedUser: auth.authedUser,
    question: questions[props.questionId],
    answered: users[auth.authedUser].answers.hasOwnProperty(props.questionId),
  }));
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState('optionOne');
  const [toHome, setToHome] = useState(false);

  const { questionId, question, answered } = this.props;
  const { optionOne, optionTwo } = question;
  const optionOneText = optionOne.text;
  const optionTwoText = optionTwo.text;

  const handleOptionChange = event => {
    this.setState({
      selectedOption: event.target.value,
    });
  };

  const handleSubmitClick = event => {
    event.preventDefault();
    const { authedUser, question } = this.props;
    dispatch(
      saveQuestionAnswerAtAll(
        authedUser,
        question.id,
        this.state.selectedOption
      )
    );
  };

  return (
    <>
      {answered ? (
        <div className="question-result">
          <QuestionOptionResult option={'optionOne'} questionId={questionId} />
          <QuestionOptionResult option={'optionTwo'} questionId={questionId} />
        </div>
      ) : (
        <div className="question-options">
          <label>
            <input
              type="radio"
              name="questionOptions"
              value="optionOne"
              checked={selectedOption === 'optionOne'}
              onChange={handleOptionChange}
            />
            {optionOneText}
          </label>
          <label>
            <input
              type="radio"
              name="questionOptions"
              value="optionTwo"
              checked={selectedOption === 'optionTwo'}
              onChange={handleOptionChange}
            />
            {optionTwoText}
          </label>
          <button type="button" onClick={handleSubmitClick}>
            Submit
          </button>
        </div>
      )}
    </>
  );
}

export default QuestionDetail;
